module.exports = __webpack_public_path__ + "static/assets/11bf76b0779a57b30e614213f43eb983.png";